import React, { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { UoUDataStoreProvider } from '@wix/ai-scheduling-assistant-data-store';
import { useAuthTokenContext } from '../context/AuthTokenContext';
import { HttpClientsContextProvider, useHttpClientsContext } from '../context/HttpClientsContext';

const OutletWithDataStore: React.FC<PropsWithChildren> = ({ children }) => {
  const { httpClient } = useHttpClientsContext();
  return <UoUDataStoreProvider httpClient={httpClient}>{children}</UoUDataStoreProvider>;
};

export const WithHttpClientsRouteWrapper: React.FC<PropsWithChildren<{ useIndividualAssistant?: boolean }>> = ({
  children,
  useIndividualAssistant,
}) => {
  const { isExpired } = useAuthTokenContext();
  if (isExpired) {
    return <Navigate to="/session-expired" replace />;
  }

  return (
    <HttpClientsContextProvider useIndividualAssistant={useIndividualAssistant}>
      <OutletWithDataStore>{children}</OutletWithDataStore>
    </HttpClientsContextProvider>
  );
};
